/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $('[data-toggle="tooltip"]').tooltip()

        $('.phone-menu .nav .dropdown').on('shown.bs.dropdown hidden.bs.dropdown', function(){ centerPhoneMenu(); });

        //Give navigation link products an active class
        $('body.single-post .nav-primary #menu-mainmenu > li:first-child').addClass('active');

        $('.nav a.dropdown-toggle').each(function(){

            //Clona first-child i submeny (Borde alltid finnas åtminstone en eftersom det är en dropdown)
            $(this).parent().addClass('dropdown');

        });
        
        if (typeof Modernizr == 'object') { 
          if (Modernizr.touchevents) { 
            $('body').addClass('no-hover');
          }
        }

        $('.hidden-md .nav a.dropdown-toggle').each(function(){

            //Clona first-child i submeny (Borde alltid finnas åtminstone en eftersom det är en dropdown)
            $(this).parent().addClass('dropdown');


            $cloned = $('ul li:first-child',$(this).parent()).clone();
            $('a',$cloned).attr('href',$(this).attr('href')).html($(this).text());


            //Ta klasserna från huvudmenyval men exkludera dropdownklassen
            var $classes = $(this).parent().attr('class').replace('dropdown','');

            //Om det finns en annan submeny som är aktiv, ta bort även active classen som kommer från huvudmenyval då en submeny är active
            $classes = $(this).parent().find('ul li.active').length > 0 ? $classes.replace('active', ''):$classes;

            //Modifiera classer,href och text på clonen för att spegla huvudmenyval
            $cloned.attr('class',$classes).find('a').attr('href',$(this).attr('href')).text($(this).text());

            //Prependa den så den hamnar först i submenyn
            $('ul',$(this).parent()).prepend($cloned);
        });

        $('.langSwitch .currentLan > a').on('click', function(e){
          e.preventDefault();
          $(this).siblings('.dropdown').toggle();
        });

        $('footer .topSearchButton, .submenu-nav .topSearchButton').each(function(){
          $(this).parent().parent().remove();
        });

        $('.banner .navbar .topSearchButton').parent().on('click', function(){
          if($('.topSearchButton', this).hasClass('fa-search')){
            $class = $('.topSearchButton', this).attr('class').replace('fa-search', 'fa-times');
          }
          else{
            $class = $('.topSearchButton', this).attr('class').replace('fa-times', 'fa-search');
          }

          $('.topSearchButton', this).attr('class', $class);
          $('.topHeader-container .hidden-xs.searchForm').slideToggle('fast');
        });

        $('header .nav-primary .navbar-header .navbar-toggle.collapsed, header .nav-primary .hidden-md .phone-menu .close-menu').on('click touch', function(e){
          e.preventDefault();
          toggleMenu();
        });


        function toggleMenu(){
          var phoneMenuWidth = $('header .nav-primary .hidden-md .phone-menu').outerWidth();

          if($('header .nav-primary .hidden-md .phone-menu').hasClass('open')){
            $('header .nav-primary .hidden-md .phone-menu').removeClass('open');
            $('header .nav-primary .hidden-md .phone-menu').animate({"margin-right": '-='+phoneMenuWidth}, 350, function(){
              $('header .nav-primary .hidden-md .phone-menu').css("margin-right", "");
            });
          }else{
            $('header .nav-primary .hidden-md .phone-menu').addClass('open');
            $('header .nav-primary .hidden-md .phone-menu').animate({"margin-right": '+='+phoneMenuWidth}, 350);
          }
        }

        $('.navigation .submenu-nav li:first-child').each(function(){
          $original = $('.navbar .hidden-xs .navbar-nav .dropdown.active > a');

          if($original.length > 0){
            $href = $original.attr('href');
            $title = $original.text();

            $clone = $(this).clone();

            $class = $original.parent().attr('class').replace('dropdown', '');

            $class = $(this).parent().find('li.active').length > 0 ? $class.replace('active', ''):$class;

            $('a', $clone).attr('href', $href).text($title).parent().attr('class', $class);
            $(this).parent().prepend($clone);
          }
        });

        // Add smooth scrolling to all links
        $("a").on('click', function(event) {

          // Make sure this.hash has a value before overriding default behavior
          if (this.hash !== "") {
            // Prevent default anchor click behavior
            event.preventDefault();

            // Store hash
            var hash = this.hash;

            // Using jQuery's animate() method to add smooth page scroll
            // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
            $('html, body').animate({
              scrollTop: ($(hash).offset().top - 83)
            }, 800, function(){
         
              // Add hash (#) to URL when done scrolling (default click behavior)
              window.location.hash = hash;
            });
          } // End if
        });

        //fire when everything is loaded
        $(window).load(function(){
          checkScroll();
          centerPhoneMenu();
        });

        //fire on resize
        $(window).on('resize', function(){
          centerPhoneMenu();
          checkScroll();
        });

        //fire on scroll
        $(window).on('scroll', function(){
          checkScroll();
        });

        $(window).on("orientationchange",function(){
          if($('header .nav-primary .hidden-md .phone-menu').hasClass('open')){
            $('header .nav-primary .hidden-md .phone-menu').css("margin-right", "0");
          }
        });

        function checkScroll(){
          if($(window).width() > 1200){
            if($(window).scrollTop() > 10){
              if($('.topHeader-container.scrolling').length === 0){
                $('.topHeader-container').addClass('scrolling');

                $('header .headlogo img').on("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd",
                 function(e){
                    //fixMenuPos();
                    $(this).off(e);
                 });
              }
            }else{
              if($('.topHeader-container.scrolling').length > 0){
                $('.topHeader-container').removeClass('scrolling');

                $('header .headlogo img').on("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd",
                function(e){
                  //fixMenuPos();
                  $(this).off(e);
                });
              }
            }
          }else{
            if($('.topHeader-container.scrolling').length > 0){
              $('.topHeader-container').removeClass('scrolling');
            }
          }
        }

        function centerPhoneMenu(){
          var offset = ($(window).height() - $('header .nav-primary .hidden-md .phone-menu ul.navbar-nav').height()) / 2;
          offset = offset - 3;
          $('header .nav-primary .hidden-md .phone-menu ul.navbar-nav').css('margin-top', offset);
        }
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'page_template_subpage': {
      init: function() {

        //fire on document load

        //fire when everything is loaded
        $(window).load(function(){
        });

        //fire on resize
        $(window).on('resize', function(){
        });

        //fire on scroll
        $(window).on('scroll', function(){
        });
      }
    },
    'page_template_vallatips_lista': {
      init: function() {

        //fire on document load

        //fire when everything is loaded
        $(window).load(function(){
          $("ul.vallatips li").click(function(){
            if($(this).hasClass("open")) return;

            $("ul.vallatips li").removeClass("open");
            $(this).addClass("open");
          });
        });

        //fire on resize
        $(window).on('resize', function(){
        });

        //fire on scroll
        $(window).on('scroll', function(){
        });
      }
    },
    'page_template_contactpage': {
      init: function() {
        $('#phone-select').on('change', function (e) {
            $('.mapTabs li a').eq($(this).val()).tab('show');
        });

        $('.mapTabs li a').on('click', function(){
          var value = $('.mapTabs li a').index(this);
          $('#phone-select').val(value);
        });
      }
    },
    'page_template_productpage': {
      init: function() {
        $(window).load(function(){ fixProductHeight(); });
        $(window).on('resize', function(){ fixProductHeight(); });

        function fixProductHeight(){
          $('.productpage .product').css('min-height', '');
          var productHeight = 0;

          $('.productpage .product').each(function(){
            if(productHeight < $(this).height()){ productHeight = $(this).height(); }
          });

          $('.productpage .product').css('min-height', productHeight);
        }
      }
    },
    'page_template_startpage': {
      init: function() {
        fixClientHeight();

        $('.quotes').flexslider({
          prevText: '<span class="icon-chevron-left-large"></span>',
          nextText: '<span class="icon-chevron-right-large"></span>',
        });

        $('.flexslider').flexslider({
          animation: "slide",
          prevText: '',
          nextText: '',
          smoothHeight: true,
          start: function(){
            sliderArrowPos();
            controlNavClass();
          },
          after: function(){
            controlNavClass();
          }
        });

        $(window).on('resize', function(){
          sliderArrowPos();
          fixClientHeight();
        });

        function sliderArrowPos(){
          if($(window).width() >= (768 - 17) && $(window).width() <= (991 - 17)){
            var imgHeight = $('.flexslider .flex-active-slide img').height();

            $('.flexslider .flex-direction-nav a').each(function(){
              var topPos = (imgHeight / 2);
              $(this).css("top", topPos);
            });
          }else{
            $('.flexslider .flex-direction-nav a').each(function(){
              $(this).css("top", '');
            });
          }
        }

        function controlNavClass(){
          if($('.flex-active-slide .slideText').length <= 0){
            $('.flexslider .flex-control-nav').addClass('no-text');
          }else{
            $('.flexslider .flex-control-nav').removeClass('no-text');
          }
        }

        function fixClientHeight(){
          $('.startpage.clients .client .kli-text').css('min-height', '');
          $('.startpage.clients .client .kli-text').css('padding-top', '');
          var clientHeight = 0;

          $('.startpage.clients .client .kli-text').each(function(){
            if(clientHeight < $(this).outerHeight()){ clientHeight = $(this).outerHeight(); }
          });

          if($(window).width() > 767){
            $('.startpage.clients .client .kli-text').css('min-height', clientHeight);
          }

          $('.startpage.clients .client .kli-text').each(function(){
            var textHeight = $('p', this).height();
            var offset = ((clientHeight - textHeight) / 2) - 6;

            if($(window).width() > 767){
              $(this).css('padding-top', offset);
            }else{
              $(this).css('padding-top', '');
            }
          });
        }
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
